import { render, staticRenderFns } from "./AddCustomerSegment.vue?vue&type=template&id=ff7e070c&scoped=true"
import script from "./AddCustomerSegment.vue?vue&type=script&lang=js"
export * from "./AddCustomerSegment.vue?vue&type=script&lang=js"
import style0 from "./AddCustomerSegment.vue?vue&type=style&index=0&id=ff7e070c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7e070c",
  null
  
)

export default component.exports